import type { WebContext } from "@reboot-dev/reboot-web";
import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { Logger } from "@moment/logging";
import type { DocumentCollabRegistry } from "@moment/reboot-differential";

import { $singletonRebootContext } from "./reboot-context.atom";
import { collabRegistryRef } from "./refs";

const logger = new Logger("collab-registry-connection");

export type CollabRegistryConnection = {
	registry: DocumentCollabRegistry.WeakReference;
	context: WebContext;
};

/**
 * The canonical Reboot connection for the DocumentCollabRegistry of a workspace.
 *
 * Returns null if the application-wide singleton Reboot `WebContext` is not available.
 */
export const $collabRegistryConnection = atomFamily((workspaceSlug: string) => {
	const connectionAtom = atom((get): CollabRegistryConnection | null => {
		const context = get($singletonRebootContext);
		if (!context) {
			logger.debug("RebootContext not available for collab registry", { workspaceSlug });
			return null;
		}

		const registry = collabRegistryRef(workspaceSlug);

		logger.debug("Created collab registry connection", { workspaceSlug });

		return { registry, context };
	});

	connectionAtom.debugLabel = `collabRegistryConnection/${workspaceSlug}`;
	return connectionAtom;
});
